import * as React from "react";
import { UitkHeading, UitkText } from "uitk-react-text";
import { UitkImage, UitkFigure } from "uitk-react-images";
import { UitkEmptyState } from "uitk-react-empty-state";
import { useLocalization } from "@shared-ui/localization-context";

export const DealsErrorFallback = () => {
  const { formatText } = useLocalization();
  const fallbackSrc: string =
    "https://a.travel-assets.com/travel-assets-manager/d4c0c838-61ca-41ee-bb38-3c3a550cbbf7/nodeals_160x160-2x.png";

  return (
    <div data-testid="deals-error-fallback" className="Deals uitk-flex-column all-y-margin-three">
      <div className="deals-error-fallback-image uitk-flex-grow-1">
        <UitkFigure className="fallback-image all-image-fit-cover">
          <UitkImage className="deals-fallback-image" alt="" src={fallbackSrc} placeholderImage={false} />
        </UitkFigure>
      </div>

      <div>
        <UitkEmptyState>
          <UitkHeading level={2} size={500}>
            {formatText("deals.fallbackView.title")}
          </UitkHeading>
          <UitkText>{formatText("deals.fallbackView.cta")}</UitkText>
        </UitkEmptyState>
      </div>
    </div>
  );
};
